import React from "react";
import { Col, Container, Row} from "react-bootstrap";

class TickDataList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            dataArrays: props.tickList,
            positionKey :"indPosition",
            indicatorValueKey: 'indValue',
            repeatValueKey : 'positionRepeat',
            displayValue : props.displayValue,

        };
        this.dateField = "time";
    }

    updateData(data) {
        this.setState({
            dataArrays : data
        })
    }

    updateIndicator(dataKey, positionKey) {
        console.log("update indicator:"+ dataKey + " positionKey " + positionKey);
        this.setState({
            positionKey :dataKey,
            indicatorValueKey: positionKey
        })
    }

    getValueByKeyAndIndex(key, index){
        let val = "unknown";
        if(this.state.dataArrays[key] != null && this.state.dataArrays[key].length >= index){
            val = this.state.dataArrays[key][index];
        }
        return val;
    }


    render() {
        let response = "";
        if (this.state.dataArrays === null || this.state.dataArrays[this.dateField] === null || this.state.dataArrays[this.dateField].length === 0){
            response = <div>No Ticks Selected</div>
        }else{
            let tickRows = [];

            for(let i =0; i < this.state.dataArrays[this.dateField].length; i++) {
                let theDate = new Date(this.state.dataArrays[this.dateField][i]);
                tickRows.push(<Row key={theDate}>
                    <Col>{theDate.toLocaleTimeString("en-US")}</Col>
                    <Col>{this.getValueByKeyAndIndex(this.state.indicatorValueKey,i)}</Col>
                    <Col>{this.getValueByKeyAndIndex(this.state.positionKey,i)}</Col>
                    <Col>{this.getValueByKeyAndIndex(this.state.repeatValueKey,i)}</Col>
                    <Col>{this.getValueByKeyAndIndex('tradeContractClosePrice',i)}</Col>
                    <Col>{this.getValueByKeyAndIndex(this.state.displayValue,i)}</Col>
                    <Col>{this.getValueByKeyAndIndex('lastExecutedOrder', i)}</Col>
                    <Col>{this.getValueByKeyAndIndex('pendingOrders',i)}</Col>
                </Row>);
            }
            response =<div className="press-grid" key={this.props.tickList}>
                {this.state.indicatorValueKey}
                <Container>
                    <Row>
                        <Col>Time</Col>
                        <Col>Value</Col>
                        <Col>Indicator</Col>
                        <Col>Position Repeat</Col>
                        <Col>Contract Price</Col>
                        <Col>{this.state.displayValue} Price</Col>
                        <Col>Last Order Executed</Col>
                        <Col>Pending Orders</Col>
                    </Row>
                    {tickRows}
                </Container>
            </div>
        }
        return response;
    }
}


export {TickDataList}
